import {
  createStyles,
  Title,
  SimpleGrid,
  Text,
  Button,
  ThemeIcon,
  Grid,
  Col,
  rem
} from "@mantine/core";
import {
  IconReceiptOff,
  IconFlame,
  IconCircleDotted,
  IconFileCode
} from "@tabler/icons-react";
import { useHistory } from "react-router-dom";
import "./Home.css";

const useStyles = createStyles((theme) => ({
  wrapper: {
    padding: `calc(${theme.spacing.xl} * 2) ${theme.spacing.xl}`
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontSize: rem(36),
    fontWeight: 900,
    lineHeight: 1.1,
    marginBottom: theme.spacing.md,
    color: theme.colorScheme === "dark" ? theme.white : theme.black
  }
}));

const features = [
  {
    icon: IconReceiptOff,
    title: "Upload any docs",
    description:
      "All packages are published under MIT license, you can use Mantine in any project"
  },
  {
    icon: IconFileCode,
    title: "Secure and Encrypted",
    description:
      "Build type safe applications, all components and hooks export types"
  },
  {
    icon: IconCircleDotted,
    title: "Cutting edge technlogies",
    description:
      "With new :focus-visible selector focus ring will appear only when user navigates with keyboard"
  },
  {
    icon: IconFlame,
    title: "Flexible",
    description:
      "Customize colors, spacing, shadows, fonts and many other settings with global theme object"
  }
];

export default function Home() {
  const { classes } = useStyles();
  const history = useHistory();

  const handleButtonClick = (route) => {
    history.push(route);
   };


  const items = features.map((feature) => (
    <div key={feature.title}>
      <ThemeIcon
        size={44}
        radius="md"
        variant="gradient"
        gradient={{ deg: 133, from: "#b356bb", to: "#5ccfec" }}
      >
        <feature.icon size={rem(26)} stroke={1.5} />
      </ThemeIcon>
      <Text fz="lg" mt="sm" fw={500}>
        {feature.title}
      </Text>
      <Text c="dimmed" fz="sm">
        {feature.description}
      </Text>
    </div>
  ));

  return (
    <div className={classes.wrapper}>
      <Grid gutter={80}>
        <Col span={12} md={5}>
          <Title className={classes.title} order={2}>
            A Generative-AI approach for docs and workspace
          </Title>
          <Text c="dimmed">Built with ease-of-use in mind.</Text>

          <div className="button-wrapper">
            <Button
              variant="gradient"
              gradient={{ deg: 133, from: "#AAFFA9", to: "#061161" }}
              size="lg"
              radius="md"
              mt="xl"
              className="custom-button"
              onClick={() => handleButtonClick("/chatpdf")}
            >
              PDF Chat
            </Button>

            <Button
              variant="gradient"
              gradient={{ deg: 133, from: "#780206", to: "#061161" }}
              size="lg"
              radius="md"
              mt="xl"
              className="custom-button"
              onClick={() => handleButtonClick("/textai")}
            >
              AI Assistant
            </Button>
          </div>

          <div className="button-wrapper">
            <Button
              variant="gradient"
              gradient={{ deg: 133, from: "#AAFFA9", to: "#061161" }}
              size="lg"
              radius="md"
              className="custom-button"
              onClick={() => handleButtonClick("/chatwebsite")}
            >
              WebChat
            </Button>

            <Button
              variant="gradient"
              gradient={{ deg: 133, from: "#780206", to: "#061161" }}
              size="lg"
              radius="md"
              className="custom-button"
              onClick={() => handleButtonClick("/voiceai")}
            >
              Voice AI
            </Button>
          </div>
        </Col>

        <Col span={12} md={7}>
          <SimpleGrid
            cols={2}
            spacing={30}
            breakpoints={[{ maxWidth: "md", cols: 1 }]}
          >
            {items}
          </SimpleGrid>
        </Col>
      </Grid>
    </div>
  );
}
